/**
 * PresetControl — Horizontal pill selector for preset values.
 */

import { Label } from '@/components/ui/label'

interface PresetOption {
  value: string
  label: string
}

interface PresetControlProps {
  value: string
  onChange: (v: string) => void
  label: string
  options: PresetOption[]
}

export function PresetControl({ value, onChange, label, options }: PresetControlProps) {
  return (
    <div className="space-y-1.5">
      <Label className="text-[13px] font-medium text-gray-600">{label}</Label>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => {
          const isSelected = value === opt.value
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={`rounded-xs px-3 py-1.5 text-xs font-medium transition-colors ${
                isSelected
                  ? 'bg-sky-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
